module.exports = __webpack_public_path__ + "challenge.png?335a2abe98ce3a593abc5d75eff81d33";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/challenge.png
// module id = 340
// module chunks = 0